import type { FC } from 'react';
import { Area, ComposedChart, Line, ResponsiveContainer, XAxis, YAxis } from 'recharts';

import { colors } from '@/design-system/colors';

import { formatAxisDate } from './bar-chart';
import { CarouselCardChartArea, CarouselCardContainer } from './carousel-card.styled';
import { CarouselCardTitle } from './carousel-card-header';
import type { CardProps } from './common';

const AXIS_FONT_SIZE = 10;
const AREA_GRADIENT_ID = 'carouselCardArea';

export const CarouselLineCard: FC<{ card: CardProps }> = ({ card }) => {
  const stroke = card.strokeColor ?? colors.brand.solid;

  return (
    <CarouselCardContainer>
      <CarouselCardTitle title={card.title} value={card.value} delta={card.delta} />

      <CarouselCardChartArea>
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={card.chartData} margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
            <defs>
              <linearGradient id={AREA_GRADIENT_ID} x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor={stroke} stopOpacity={0.16} />
                <stop offset="100%" stopColor={stroke} stopOpacity={0} />
              </linearGradient>
            </defs>

            <XAxis
              dataKey="date"
              tickFormatter={formatAxisDate}
              tick={{ fill: colors.text.secondary, fontSize: AXIS_FONT_SIZE }}
              axisLine={false}
              tickLine={false}
              minTickGap={24}
            />
            <YAxis hide domain={['dataMin', 'dataMax']} />

            <Area
              type="monotone"
              dataKey="count"
              stroke="none"
              fill={`url(#${AREA_GRADIENT_ID})`}
              isAnimationActive={false}
            />
            <Line type="monotone" dataKey="count" stroke={stroke} strokeWidth={2} dot={false} />
          </ComposedChart>
        </ResponsiveContainer>
      </CarouselCardChartArea>
    </CarouselCardContainer>
  );
};
